import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-310"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.685 8.455a3.172 3.172 0 0 0 1.243-.253 4.61 4.61 0 0 0 6.144 0 3.185 3.185 0 1 0 1.243-6.116 3.146 3.146 0 0 0-.396.04 4.675 4.675 0 0 0-7.838 0 3.146 3.146 0 0 0-.397-.04 3.184 3.184 0 1 0 0 6.369zm0-5.37a1.236 1.236 0 0 1 .17.02l.101.013a1 1 0 0 0 .962-.444 3.675 3.675 0 0 1 6.164 0 1 1 0 0 0 .962.444l.102-.014a1.236 1.236 0 0 1 .17-.018 2.184 2.184 0 1 1-.853 4.196 1 1 0 0 0-1.05.167 3.61 3.61 0 0 1-4.827 0 1 1 0 0 0-1.049-.167 2.185 2.185 0 1 1-.852-4.196zM7 13.713a1 1 0 0 0 2 0 6.604 6.604 0 0 0-1-2 6.604 6.604 0 0 0-1 2zm-2.527-2.02a1 1 0 0 0 2 0 6.604 6.604 0 0 0-1-2 6.604 6.604 0 0 0-1 2zm5.011 0a1 1 0 0 0 2 0 6.604 6.604 0 0 0-1-2 6.604 6.604 0 0 0-1 2zm-6.732-.833a5.192 5.192 0 0 0-.786-1.573 5.192 5.192 0 0 0-.786 1.573.786.786 0 0 0 1.572 0zm-.347 2.746a.786.786 0 0 0 1.572 0 5.192 5.192 0 0 0-.786-1.573 5.192 5.192 0 0 0-.786 1.573zm10.835-2.738a.786.786 0 0 0 1.573 0 5.194 5.194 0 0 0-.786-1.573 5.194 5.194 0 0 0-.787 1.573zm-1.209 2.738a.786.786 0 0 0 1.573 0 5.192 5.192 0 0 0-.786-1.573 5.192 5.192 0 0 0-.787 1.573z",
  style: {"fill-rule":"evenodd"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }